// Vietnamese
export const vi = {
  'app.name':           'Kardolive',
  'app.tagline':        'Cổng khách hàng',
  'app.signOut':        'Đăng xuất',

  'login.email':        'Email',
  'login.password':     'Mật khẩu',
  'login.signIn':       'Đăng nhập',
  'login.signingIn':    'Đang đăng nhập…',
  'login.failed':       'Đăng nhập thất bại',
  'login.newAccount':   'Mới sử dụng Kardolive?',
  'login.createAccount':'Tạo tài khoản miễn phí →',

  'nav.workspace':      'Không gian làm việc',
  'nav.templates':      'Mẫu',
  'nav.live':           'Trực tiếp',
  'nav.rooms':          'Phòng & trò chuyện',
  'nav.content':        'Nội dung',
  'nav.developer':      'Nhà phát triển',
  'nav.account':        'Tài khoản',

  'nav.overview':       'Tổng quan',
  'nav.projects':       'Dự án',
  'nav.chat':           'Bảng chat',
  'nav.sessions':       'Phiên',
  'nav.streams':        'Phát trực tiếp',
  'nav.studio':         'Studio',
  'nav.recordings':     'Bản ghi',
  'nav.apiKeys':        'Khóa API',
  'nav.webhooks':       'Webhooks',
  'nav.webhookTester':  'Trình thử Webhook',
  'nav.networkTest':    'Kiểm tra mạng',
  'nav.embed':          'Tiện ích nhúng',
  'nav.sdk':            'SDK & tài liệu',
  'nav.docs':           'Tài liệu nhà phát triển',
  'nav.analytics':      'Phân tích',
  'nav.settings':       'Cài đặt',

  'overview.welcome':       'Chào mừng trở lại, {name}',
  'overview.plan':          '{tenant} · gói {plan}',
  'overview.newStream':     'Phát mới',
  'overview.kpi.live':           'Đang trực tiếp',
  'overview.kpi.live.broadcasting': 'phát đang chạy',
  'overview.kpi.live.nothing':    'không có gì trực tiếp',
  'overview.kpi.total':           'Tổng số phát',
  'overview.kpi.total.sub':       'mọi thời điểm',
  'overview.kpi.sessions':        'Phiên · 30 ngày',
  'overview.kpi.sessions.sub':    'sự kiện xuất bản',
  'overview.kpi.recordings':      'Bản ghi',
  'overview.kpi.recordings.sub':  'sẵn sàng phát',
  'overview.recentStreams':       'Phát gần đây',
  'overview.recentSessions':      'Phiên gần đây',
  'overview.viewAll':             'Xem tất cả →',
  'overview.empty.title':         'Chưa có phát nào',
  'overview.empty.body':          'Tạo phát đầu tiên của bạn để bắt đầu phát sóng.',
  'overview.empty.action':        'Tạo phát',
  'overview.noSessions':          'Chưa có phiên nào',

  'status.live':        'TRỰC TIẾP',
  'status.idle':        'KHÔNG HOẠT ĐỘNG',
  'status.ended':       'KẾT THÚC',
  'status.archived':    'LƯU TRỮ',

  'common.save':        'Lưu',
  'common.cancel':      'Hủy',
  'common.delete':      'Xóa',
  'common.edit':        'Chỉnh sửa',
  'common.create':      'Tạo',
  'common.confirm':     'Xác nhận',
  'common.loading':     'Đang tải…',
  'common.error':       'Lỗi',
  'common.retry':       'Thử lại',

  // Dashboard navigation and account controls.
  "nav.skipContent": "Chuyển đến nội dung trang",
  "nav.streamTemplates": "Mẫu phát trực tiếp",
  "nav.boards": "Bảng tương tác",
  "nav.menu": "Mở điều hướng",
  "nav.closeMenu": "Đóng điều hướng",
  "nav.scenarios": "Tình huống sử dụng",
  "nav.premieres": "Công chiếu",
  "nav.clips": "Đoạn video",
  "dashboard.account": "Tài khoản",
  "dashboard.language": "Ngôn ngữ",
  "dashboard.appearance": "Giao diện",
  "nav.allStreams": "Tất cả buổi phát",
  "nav.destinations": "Đích phát",
  "nav.ecommerce": "Thương mại điện tử",
  "nav.products": "Sản phẩm",
  "nav.services": "Dịch vụ",
  "nav.collections": "Bộ sưu tập",
  "nav.orders": "Đơn hàng",
  "nav.commerceSettings": "Cài đặt thương mại",
  "nav.engagement": "Tương tác",
  "theme.light": "Chuyển sang chế độ sáng",
  "theme.dark": "Chuyển sang chế độ tối",
  "role.owner": "Chủ sở hữu",
  "role.admin": "Quản trị viên",
  "role.member": "Thành viên",
  "role.viewer": "Người xem",

  // Live Stream page content: never translate stored event names or API values.
  "streams.active": "Đang sử dụng",
  "streams.archived": "Đã lưu trữ",
  "streams.monitor": "Giám sát nguồn phát",
  "streams.create": "Tạo buổi phát trực tiếp",
  "streams.list": "Danh sách",
  "streams.grid": "Lưới",
  "streams.view": "Chế độ xem buổi phát",
  "streams.searchLabel": "Tìm sự kiện",
  "streams.searchHint": "Tìm theo tên sự kiện",
  "streams.solutionFilter": "Lọc sự kiện theo loại",
  "streams.statusFilter": "Lọc sự kiện theo trạng thái",
  "streams.dateFilter": "Lọc theo ngày tạo",
  "streams.allSolutions": "Tất cả loại",
  "streams.custom": "Thiết lập có sẵn hoặc tùy chỉnh",
  "streams.allStatuses": "Tất cả trạng thái",
  "streams.anyTime": "Mọi ngày tạo",
  "streams.last7": "Tạo trong 7 ngày qua",
  "streams.last30": "Tạo trong 30 ngày qua",
  "streams.count": "Hiển thị {shown} trên {total} sự kiện",
  "streams.noMatch": "Không có sự kiện khớp với bộ lọc.",
  "streams.clearFilters": "Xóa bộ lọc",
  "streams.refreshFailed": "Không thể làm mới danh sách",
  "streams.loadFailed": "Không thể tải các buổi phát",
  "streams.stale": "Đang hiển thị danh sách đã tải trước đó. Trạng thái có thể đã thay đổi.",
  "streams.connectionHint": "Kiểm tra kết nối rồi tải lại danh sách.",
  "streams.retrying": "Đang thử lại…",
  "streams.retry": "Thử lại",
  "streams.restoreFailed": "Không thể khôi phục buổi phát",
  "streams.restoreHint": "Kiểm tra kết nối và làm mới danh sách để xác nhận trạng thái trước khi thử lại.",
  "streams.unused": "Buổi phát chưa sử dụng: {count}",
  "streams.unusedHint": "Chưa phát sóng hoặc có bản phát lại. Hãy lưu trữ để sắp xếp danh sách; không có gì bị xóa.",
  "streams.reviewArchive": "Xem và lưu trữ",
  "streams.loading": "Đang tải các buổi phát…",
  "streams.archiveEmpty": "Chưa có mục lưu trữ. Buổi phát đã lưu trữ và bản phát lại sẽ ở đây cho đến khi được khôi phục.",
  "streams.restore": "Khôi phục",
  "streams.firstTitle": "Tạo buổi phát đầu tiên",
  "streams.firstBody": "Chọn thiết lập cho bán hàng, lớp học hoặc dịch vụ, hay bắt đầu với buổi phát trống. Phát từ trình duyệt, điện thoại hoặc OBS.",
  "streams.blank": "Buổi phát trống",
  "streams.broadcasts": "Lượt phát: {count}",
  "streams.replays": "Bản phát lại: {count}",
  "streams.sessions": "Phiên: {count}",
  "streams.recordings": "Bản ghi: {count}",
  "streams.mode.BROADCAST": "Phát sóng",
  "streams.mode.LOW_LATENCY": "Độ trễ thấp",
  "streams.mode.REALTIME": "Thời gian thực",
  "streams.key": "Khóa",
  "streams.archiveTitle": "Lưu trữ buổi phát chưa sử dụng",
  "streams.archiveHint": "Những buổi phát này chưa từng phát sóng. Bạn có thể khôi phục bất cứ lúc nào trong thẻ Đã lưu trữ.",
  "streams.archiveFailed": "Không thể lưu trữ {count} buổi phát; có thể chúng đã bắt đầu phát trực tiếp. Các buổi khác đã được lưu trữ.",
  "streams.archiving": "Đang lưu trữ…",
  "streams.archiveCount": "Lưu trữ {count}",
  "streamType.webinar": "Hội thảo kinh doanh và ra mắt",
  "streamType.classroom": "Lớp học và gia sư",
  "streamType.training": "Đào tạo doanh nghiệp",
  "streamType.conference": "Hội nghị và triển lãm",
  "streamType.shopping": "Mua sắm trực tiếp",
  "streamType.auction": "Đấu giá trực tiếp",
  "streamType.consultation": "Tư vấn riêng",
  "streamType.creator": "Nhà sáng tạo và cộng đồng trực tiếp",
  "streamType.audio": "Phòng âm thanh và podcast",
  "streamType.sports": "Thể thao và thể thao điện tử",
  "streamType.performance": "Hòa nhạc và biểu diễn",
  "streamType.community": "Sinh hoạt tôn giáo và gây quỹ",
  "streamType.tour": "Tham quan và trình diễn",
  "streamType.fitness": "Thể dục và workshop",
  "streamType.public-meeting": "Tin tức và họp công khai",
  "streamType.continuous": "Kênh liên tục và camera",
  "streams.close": "Đóng",
};
